/* eslint-disable multiline-ternary */
import { Fragment, useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Col,
  Input,
  Nav,
  NavItem,
  NavLink,
  Progress,
  Row,
  Spinner,
  TabContent,
  Table,
  TabPane,
} from 'reactstrap'
import axios from 'axios'
import { AlertCircle, CheckCircle, Clock, XCircle } from 'react-feather'

// ** Third Party Components
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
// styles import
import '@styles/react/libs/file-uploader/file-uploader.scss'
import { useParams } from 'react-router-dom'
import SignFormWizard from './components/sign-form-wizard'

import '@styles/react/libs/react-select/_react-select.scss'
import pdf from '@src/assets/images/pdf.png'
import RubriDoc from '@src/assets/images/logo/RubriDoc.png'
import crediq from '@src/assets/images/logo/crediq.png'
import moment from 'moment/moment'
import styles from './components/styles.module.scss'
import PDFViewer from './components/pdf-viewer'

const MySwal = withReactContent(Swal)

const SignDocument = () => {
  const params = useParams()
  const [loading, setLoading] = useState(false)
  const [locationData, setLocationData] = useState({})
  const [mobile, setMobile] = useState(false)
  // habilita o deshabilita la pantalla de los terminos y condiciones
  const [showTC, _] = useState(() => {
    const tycShowed = localStorage.getItem('tyc-showed')
    return !(tycShowed && tycShowed === params.documentAwsId)
  })
  const [finishTYC, setFinishTYC] = useState(false)
  const [checks, setChecks] = useState([])

  const [documents, setDocuments] = useState([])
  const [pdfActive, setPdfActive] = useState(0)
  const [expireDate, setExpireDate] = useState('')
  const [expirePage, setExpirePage] = useState(false)
  const [errorURL, setErrorURL] = useState(false)

  const [clientInfo, setClientInfo] = useState(null)
  const [clientIp, setClientIp] = useState(null)

  const [permitLocation, setPermitLocation] = useState(false)
  const [coordinates, setCoordinates] = useState(null)

  useEffect(() => {
    if (expirePage) {
      localStorage.clear()
    }
  }, [expirePage])

  const calculateLocation = async (latitude, longitude) => {
    const MAPS_API_KEY = '664815a22ee9e493682149byqea0943'
    let dataLocation = {
      latitude,
      longitude,
    }
    try {
      const requestLocationGeo = await axios.get(
        `https://geocode.maps.co/reverse?api_key=${MAPS_API_KEY}&lat=${latitude}&lon=${longitude}`
      )
      const responseLocation = requestLocationGeo.data.address
      const restDataLocation = {
        road: responseLocation.road || null,
        city:
          responseLocation.city ||
          responseLocation.municipality ||
          responseLocation.county ||
          responseLocation.town ||
          null,
        country: responseLocation.country,
        region: responseLocation.state || responseLocation.region,
      }
      dataLocation = {
        ...dataLocation,
        rest: restDataLocation,
      }
      setLocationData(dataLocation)
    } catch (e) {
      const requestLocationNom = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
      )
      const responseLocation = requestLocationNom.data.address
      const restDataLocation = {
        road: responseLocation.road || null,
        city:
          responseLocation.city ||
          responseLocation.municipality ||
          responseLocation.county ||
          responseLocation.town ||
          null,
        country: responseLocation.country,
        region: responseLocation.state || responseLocation.region || null,
      }
      dataLocation = {
        ...dataLocation,
        rest: restDataLocation,
      }
      setLocationData(dataLocation)
    }
  }

  useEffect(() => {
    if (permitLocation && coordinates) {
      const latitude = coordinates.latitude
      const longitude = coordinates.longitude
      calculateLocation(latitude, longitude)
    }
  }, [permitLocation])

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  }

  const getPosition = (data) => {
    if (data) {
      setCoordinates({
        latitude: data.coords.latitude,
        longitude: data.coords.longitude,
      })
      setPermitLocation(true)
    }
  }

  const error = (err) => {
    console.warn(`ERROR(${err.code}): ${err.message}`)
  }

  const toggleDocument = (tab) => {
    setPdfActive(tab)
  }

  const expireDateRequest = async () => {
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/documents/getClaimsToken`,
        {
          token: params.token,
        }
      )
      setExpireDate(result.data.expires)
      setExpirePage(result.data.expired)
    } catch (error) {
      setDocuments([])
      setLoading(false)
      setErrorURL(true)
    }
  }

  const generateDocuments = async (documentsAwsId, documentsNames) => {
    const headers = new Headers({
      Authorization: `Bearer ${params.token}`,
      'Content-Type': 'application/json',
    })

    const requestsByTitle = documentsAwsId.map((awsId, idx) => {
      const documentTitle = documentsNames[idx]
      const clientName = params.clientName

      const encodedTitle = encodeURIComponent(documentTitle)
      const encodedClientName = encodeURIComponent(clientName)
      const url = `${process.env.REACT_APP_API_URL}/documents/getDocumentByTitle/${encodedTitle}-${encodedClientName}-${awsId}`

      return fetch(url, { method: 'GET', headers })
        .then((response) => response.json())
        .then((list) => list?.[0])
        .catch(() => null)
    })
    const byTitle = (await Promise.allSettled(requestsByTitle)).filter((item) =>
      item.status === 'fulfilled' && (item.value !== null && item.value !== undefined)
    )

    if (byTitle.length !== requestsByTitle.length) {
      setDocuments([])
      setLoading(false)
      setErrorURL(true)

      return
    }

    const requestsDocuments = byTitle.map(({value:doc}) => {
      const id = doc.id
      const title = doc.title
      const url = `${process.env.REACT_APP_API_NODE_URL}/document/${params.clientName}/${title}/${id}`

      if (!params.clientName || !title || !id) {
        return Promise.reject(null)
      }

      return fetch(url, { method: 'GET', headers })
        .then((response) => {
          if (!response.ok) {
            return null
          }

          return response.json()
        })
        .catch(() => null)
    })

    const docs = (await Promise.allSettled(requestsDocuments)).filter((item) =>
      item.status === 'fulfilled' && item.value !== null && item.value !== undefined
    )

    if (requestsDocuments.length !== docs.length) {
      setDocuments([])
      setLoading(false)
      setErrorURL(true)

      return
    }

    const documentsResult = await Promise.all(requestsDocuments)

    setDocuments(documentsResult)
    setLoading(false)
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(getPosition, error, options)
    const documentsAwsId = params.documentAwsId.split(',')
    const documentsNames = params.documentNames.split(',')
    if (documentsAwsId.length) {
      setLoading(true)
      generateDocuments(documentsAwsId, documentsNames)
    }
    expireDateRequest()
  }, [])

  const getBigDataCloud = async () => {
    try {
      const baseUrlCloud = 'https://api-bdc.net/data'

      // Llamada a client-info
      const dataResultClient = await axios.get(
        `${baseUrlCloud}/client-info`
      )
      setClientInfo(dataResultClient.data)
    } catch (error) {
      console.error('Error al obtener client-info:', error)
      setClientInfo(null) // O establece un valor predeterminado si es necesario
    }

    try {
      // Llamada a client-ip
      const dataResultIp = await axios.get(
        'https://api.bigdatacloud.net/data/client-ip'
      )
      setClientIp(dataResultIp.data)
    } catch (error) {
      console.error('Error al obtener client-ip:', error)
      setClientIp(null) // O establece un valor predeterminado si es necesario
    }
  }

  useEffect(() => {
    if (!clientInfo || !clientIp) {
      getBigDataCloud()
    }
  }, [finishTYC, checks])

  const getUrlDocumentSigned = (results) =>
    results
      .filter((result) =>
        checks.some(
          (check) => {
            const societyValidation = (check.society === null || check.society === undefined)
            const documentValidation = check.id === result.documentId

            return societyValidation && documentValidation
          }
        )
      )
      .map(
        (result) =>
          `<a href="${result.documentUrl}" target="_blank" download>${result.documentName}</a>`
      )
      .join('<br>')

  const MAX_SIGN_ATTEMPTS = 15

  const sign = async (event, attempt = 1) => {
    setLoading(true)

    const results = []

    try {
      await Promise.all(
        checks.map(async (item) => {
          let location = null
          if (permitLocation) {
            location = Object.values(locationData.rest)
              .filter((x) => x)
              .join(', ')
          }

          // console.log('item: ', item)

          const data = {
            client_id: localStorage.getItem('client-document'),
            signer_name: localStorage.getItem('client-name'),
            client_name: params.clientName,
            document_id: item.id,
            document_name: item.documentName,
            document_size: item.documentSize,
            ip: clientIp.ipString || '0.0.0.0',
            os: clientInfo.os ? `${clientInfo.os}` : null,
            device_model: clientInfo.userAgentDisplay
              ? `${clientInfo.userAgentDisplay}`
              : null,
            browser: clientInfo.userAgent
              ? `${clientInfo.userAgent}`
              : null,
            location,
            lat_long: locationData.latitude
              ? `${locationData.latitude}, ${locationData.longitude}`
              : null,
            language: clientInfo.userLanguages?.length
              ? clientInfo.userLanguages[0]
              : 'en',
            device: clientInfo.device ? clientInfo.device : null,
          }

          try {
            const res = await fetch(
              `${process.env.REACT_APP_API_NODE_URL}/sign/document`,
              {
                method: 'POST',
                headers: {
                  Authorization: `Bearer ${params.token}`,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
              }
            ).then((response) => response.json())

            results.push(res)
          } catch (err) {
            const errorMessage =
              err.message ?? 'Tiempo de solicitud excedido'
            throw new Error(errorMessage)
          }
        })
      )

      await fetch(
        `${process.env.REACT_APP_API_URL}/documents/signedDocumentNotification`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${params.token}`,
            'Content-Type': 'application/json',
          },
        }
      )
      // console.log('checks: ', checks)
      // console.log('results: ', results)

      const linksHtml = getUrlDocumentSigned(results)
      // console.log('linksHtml: ', linksHtml)
      // Muestra el modal con todos los documentos al final del bucle
      await MySwal.fire({
        title: 'Firmado',
        html: linksHtml
          ? `Haga click si desea descargar el documento: <br> <br>
                        ${getUrlDocumentSigned(results)}`
          : '',
        icon: 'success',
        confirmButtonText: 'Finalizar',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
      })
      // Actualiza la página después de confirmar
      window.location.reload()
    } catch (err) {
      if (attempt < MAX_SIGN_ATTEMPTS) {
        await new Promise((resolve) => setTimeout(resolve, 1000)) // Espera 1 segundo
        sign(event, attempt + 1)
      } else {
        await MySwal.fire({
          title: 'Error al firmar el documento',
          html: `Esto ha tomado más de lo esperado. </br> Inténtelo nuevamente.`,
          icon: 'danger',
          showCloseButton: false,
          showCancelButton: false,
          confirmButtonText: 'Intentarlo de nuevo',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
          buttonsStyling: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            setLoading(false)
            sign(event)
          }
        })
      }
    }
  }

  const rejectDocument = async () => {
    const { value: text } = await MySwal.fire({
      title: 'Desea solicitar cambio?',
      input: 'textarea',
      inputLabel: 'Razón de solicitud de cambio?',
      inputPlaceholder: 'Agrega un comentario...',
      inputAttributes: {
        'aria-label': 'Escribe tu comentario aqui',
        style: 'margin: 20px;',
      },
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value.trim() !== '') {
            resolve()
          } else {
            resolve('La razón es obligatoria')
          }
        })
      },
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-outline-primary ms-1',
      },
      buttonsStyling: false,
    })

    if (text) {
      setLoading(true)

      checks.forEach((item, index) => {
        const data = {
          client_id: localStorage.getItem('client-document'),
          company_name: params.clientName,
          document_name: item.documentName,
          document_id: item.id,
          observation: text,
        }
        const resultDocument = async () => {
          return await axios.post(
            `${process.env.REACT_APP_API_NODE_URL}/reject/document`,
            data
          )
        }

        resultDocument()
          .then(async (res) => {
            if (res.data.documentName) {
              await MySwal.fire({
                title: 'Documento Rechazado',
                html: `Documento ${res.data.documentName} se ha rechazado. <span style="display: block; position: relative; margin-top: 10px">
                        <b>Causa: </b> ${text}
                        </span> <hr>`,
                icon: 'warning',
                showCloseButton: false,
                showCancelButton: false,
                confirmButtonText: 'Finalizar',
                customClass: {
                  confirmButton: 'btn btn-warning',
                },
                buttonsStyling: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed && index + 1 === checks.length) {
                  window.location.reload()
                }
              })
            } else {
              await MySwal.fire({
                title: 'Error al rechazar el documento',
                html: `El documento no se ha logrado rechazar. <span style="display: block; position: relative; margin-top: 10px">
                        <b>Causa: </b> ${res.data.resultStatusDocument}
                        </span> <hr>`,
                icon: 'danger',
                showCloseButton: false,
                showCancelButton: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
                buttonsStyling: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  setLoading(false)
                  window.location.reload()
                }
              })
            }
          })
          .catch(async (err) => {
            await MySwal.fire({
              title: 'Error al rechazar el documento',
              html: `El documento no se ha logrado rechazar. <span style="display: block; position: relative; margin-top: 10px">
                        <b>Causa: </b> ${err.data}
                        </span> <hr>`,
              icon: 'danger',
              showCloseButton: false,
              showCancelButton: false,
              confirmButtonText: 'Aceptar',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
              buttonsStyling: false,
              allowEscapeKey: false,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                setLoading(false)
                window.location.reload()
              }
            })
          })
      })
    }
  }

  let errors = null

if (!loading) {
    if (expirePage) {
      errors = <Row className={'justify-content-center'}>
          <Col
            style={{
              paddingTop: '15%',
            }}
            md="8"
            sm="12"
            className={'px-5'}
          >
            <Card>
              <CardBody className="p-5 text-center">
                <Clock
                  size="32"
                  className="mb-1"
                />
                <h2 className="mb-1 fw-bolder">¡La URL ha expirado!</h2>
                <CardText
                  style={{
                    fontSize: '18px',
                  }}
                >
                  Estimad@ cliente, su enlace a expirado, favor comuníquese
                  con su ejecutivo para enviárselo nuevamente.
                  <br />
                  ¡Gracias por escoger a CREDIQ!
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
    } else if (errorURL) {
      errors = <Row className={'justify-content-center'}>
          <Col
            style={{
              paddingTop: '15%',
            }}
            md="8"
            sm="12"
            className={'px-5'}
          >
            <Card>
              <CardBody className="p-5 text-center">
                <AlertCircle
                  size="32"
                  className="mb-1"
                />
                <h2 className="mb-1 fw-bolder">¡Verificar URL!</h2>
                <CardText
                  style={{
                    fontSize: '18px',
                  }}
                >
                  Estimad@ cliente, La URL no es correcta, por favor comunicarse con su asesor.
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
    }
  }

  return (
    <Fragment>
      {loading && (
        <div className="row">
          <div className="col-12 px-2 py-4 text-center">
            <Spinner size="lg" />
            <CardText className={'py-1 fs-5'}>Cargando...</CardText>
          </div>
        </div>
      )}

      {errors}

      {!loading && !expirePage && !finishTYC && documents.length > 0 && (
        <Row>
          <SignFormWizard
            handleFinish={setFinishTYC}
            token={params.token}
            showTC={showTC}
            ids={params.documentAwsId}
            client={params.clientName}
            setMobile={setMobile}
            mobile={mobile}
          />
        </Row>
      )}

      {!loading && !expirePage && finishTYC && documents.length > 0 && (
        <div className="row">
          <div className="col-12 px-2 py-1">
            <Card>
              <CardHeader>
                <h2>Firmar Documentos</h2>
              </CardHeader>
              <CardBody>
                <CardText>
                  Previsualiza la información y firma este documento
                </CardText>

                <Row className="">
                  <Col
                    className="pt-2"
                    md={{ size: 7, order: 1 }}
                    xs={{ size: 12, order: 1 }}
                  >
                    <Nav pills>
                      {documents.map((document, index) => {
                        return (
                          <NavItem key={index}>
                            <NavLink
                              active={pdfActive === index}
                              onClick={() => {
                                toggleDocument(index)
                              }}
                            >
                              {document.name
                                ?.toString()
                                .replaceAll('.pdf', '')}
                            </NavLink>
                          </NavItem>
                        )
                      })}
                    </Nav>

                    <div>
                      <hr />
                      <span
                        className={'py-2 d-block fs-3 fw-bold text-center'}
                      >
                        Documento {pdfActive + 1} de {documents.length}
                      </span>
                      <Progress
                        value={((pdfActive + 1) / documents.length) * 100}
                      />
                    </div>

                    <TabContent
                      className="py-50"
                      activeTab={pdfActive}
                    >
                      {documents.map((document, index) => {
                        return (
                          <TabPane
                            tabId={index}
                            key={index}
                          >
                            {document.status === 1 &&
                              !document.signerStatus && (
                                <>
                                  <PDFViewer
                                    isActive={pdfActive === index}
                                    url={`${process.env.REACT_APP_API_URL}/documents/download/${document.id}`}
                                    token={params.token}
                                    style={{
                                      display: 'inline-flex',
                                      height: mobile ? '480px' : '1065px',
                                      width: '100%',
                                    }}
                                  />
                                </>
                              )}

                            {(document.status === 2 ||
                              document.signerStatus) && (
                              <div className="row justify-content-center pt-3">
                                <div className="col-12 px-2 py-1 text-center ">
                                  <Alert color="success">
                                    <div className="alert-body py-3">
                                      <CheckCircle size={32} />
                                      <h3 className="text-success pt-2">
                                        Este documento ya ha sido{' '}
                                        <strong>firmado</strong>!
                                      </h3>
                                    </div>
                                  </Alert>
                                  {document.status === 2 && (
                                    <a
                                      href={`data:application/pdf;base64,${document.data}`}
                                      download={document.name}
                                    >
                                      <span
                                        className={
                                          'py-2 d-block fs-4 fw-bold text-center'
                                        }
                                      >
                                        Descargar documento firmado
                                      </span>
                                    </a>
                                  )}
                                </div>
                              </div>
                            )}

                            {document.status === 3 && (
                              <div className="row justify-content-center pt-3">
                                <div className="col-12 px-2 py-1 text-center ">
                                  <Alert color="danger">
                                    <div className="alert-body py-3">
                                      <XCircle size={32} />
                                      <h3 className="text-danger pt-2">
                                        Este documento ha solicitado{' '}
                                        <strong>cambio</strong>!
                                      </h3>
                                    </div>
                                  </Alert>
                                </div>
                              </div>
                            )}

                            {document.status === 4 && (
                              <div className="row justify-content-center pt-3">
                                <div className="col-12 px-2 py-1 text-center">
                                  <Alert color="warning">
                                    <div className="alert-body py-3">
                                      <AlertCircle size={32} />
                                      <h3 className="text-warning pt-2">
                                        Este documento{' '}
                                        <strong> ha sido anulado</strong>
                                      </h3>
                                    </div>
                                  </Alert>
                                </div>
                              </div>
                            )}

                            {!document.status && (
                              <div className="row justify-content-center pt-3">
                                <div className="col-12 px-2 py-1 text-center">
                                  <Alert color="warning">
                                    <div className="alert-body py-3">
                                      <AlertCircle size={32} />
                                      <h3 className="text-warning pt-2">
                                        Este documento{' '}
                                        <strong>
                                          {' '}
                                          ya no existe o ha expirado
                                        </strong>
                                        , por favor solicite un nuevo
                                        documento
                                      </h3>
                                    </div>
                                  </Alert>
                                </div>
                              </div>
                            )}
                          </TabPane>
                        )
                      })}
                    </TabContent>
                  </Col>

                  <Col
                    className="pt-2"
                    md={{ size: 5, order: 2 }}
                    xs={{ size: 12, order: 2 }}
                  >
                    <Row>
                      <Col
                        md={{ size: 7, order: 0 }}
                        xs={{ size: 6, order: 0 }}
                      >
                        <h3 className={'pb-1'}>Instrucciones</h3>
                        <hr />
                      </Col>

                      <Col
                        md={{ size: 5, order: 1 }}
                        xs={{ size: 6, order: 1 }}
                      >
                        <img
                          src={crediq}
                          className={'ps-2 text-end'}
                          style={{
                            maxWidth: '100%',
                            maxHeight: '39px',
                            float: 'right',
                          }}
                          alt={'crediq'}
                        />
                      </Col>
                    </Row>

                    <Col
                      md={{ size: 12, order: 1 }}
                      xs={{ size: 12, order: 1 }}
                    >
                      <div className={'py-1'}>
                        <p>
                          Por favor siga las siguientes instrucciones:{' '}
                        </p>
                        <ul>
                          <li
                            className={`${styles.textJustify} pt-1 d-none`}
                          >
                            Previo haber sido identificado con el
                            procedimiento de identificación anterior y
                            registro de mi prueba de vida, declaro haber
                            leído cada uno de los documentos que se
                            suscriben, marcando cada uno en señal de
                            aceptación de las condiciones contenidas en los
                            mismos
                          </li>
                          <li className={`${styles.textJustify} pt-1`}>
                            Seleccione a cada documento marcando la casilla
                            correspondiente para efectuar una acción.
                          </li>
                          <li className={`${styles.textJustify} pt-1`}>
                            Este enlace expira el dia
                            <strong>
                              {' '}
                              {moment(
                                expireDate,
                                'DD-MM-YYYY hh:mm:ss'
                              ).format('DD/MM/YYYY')}{' '}
                            </strong>
                            a las
                            <strong>
                              {' '}
                              {moment(
                                expireDate,
                                'DD-MM-YYYY hh:mm:ss'
                              ).format('hh:mm a')}
                            </strong>
                          </li>
                        </ul>

                        <Table
                          className={'my-2'}
                          borderless
                          responsive
                        >
                          <thead>
                            <tr>
                              <th width={'20%'}>Seleccione</th>
                              <th width={'80%'}>Documento</th>
                            </tr>
                          </thead>
                          <tbody>
                            {documents.map((document, index) => {
                              return (
                                <Fragment key={index}>
                                  {document.status === 1 &&
                                    !document.signerStatus && (
                                      <tr>
                                        <td className={'text-center'}>
                                          <CardText className="form-check form-check-inline text-center cursor-pointer">
                                            <Input
                                              className={'cursor-pointer'}
                                              type="checkbox"
                                              defaultChecked={false}
                                              onChange={(e) => {
                                                if (e.target.checked) {
                                                  setChecks((old) => [
                                                    ...old,
                                                    {
                                                      id: document.id,
                                                      documentName:
                                                        document.documentName,
                                                      documentSize:
                                                        document.size,
                                                      society:
                                                        document.societyId,
                                                    },
                                                  ])
                                                } else {
                                                  setChecks(
                                                    checks.filter(
                                                      (a) =>
                                                        a.documentName !==
                                                        document.documentName
                                                    )
                                                  )
                                                }
                                              }}
                                            />
                                          </CardText>
                                        </td>
                                        <td className={'cursor-pointer'}>
                                          <div
                                            className={
                                              'cursor-pointer text-capitalize'
                                            }
                                            onClick={() =>
                                              setPdfActive(index)
                                            }
                                          >
                                            <img
                                              className="me-75"
                                              src={pdf}
                                              alt={document.name}
                                              height="20"
                                              width="20"
                                            />
                                            {document.name
                                              ?.toString()
                                              .replaceAll('.pdf', '')}
                                          </div>
                                        </td>
                                      </tr>
                                    )}

                                  {(document.status === 2 ||
                                    document.signerStatus) && (
                                    <tr>
                                      <td className={'text-center'}>
                                        <CardText className="form-check form-check-inline text-center">
                                          <Input
                                            type="checkbox"
                                            defaultChecked={false}
                                            disabled
                                          />
                                        </CardText>
                                      </td>
                                      <td>
                                        <div
                                          className={
                                            'text-capitalize text-muted'
                                          }
                                          onClick={() =>
                                            setPdfActive(index)
                                          }
                                        >
                                          <img
                                            className="me-75"
                                            src={pdf}
                                            alt={document.name}
                                            height="20"
                                            width="20"
                                          />
                                          {document.name
                                            ?.toString()
                                            .replaceAll('.pdf', '')}
                                          (firmado)
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </Fragment>
                              )
                            })}

                            {documents.filter((a) => a.status === 2)
                              .length === documents.length && (
                              <tr>
                                <td colSpan={2}>
                                  <span
                                    className={
                                      'd-block p-3 m-0 m-auto text-center'
                                    }
                                  >
                                    No hay documentos para firmar!
                                  </span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>

                    <Col
                      style={{
                        paddingBottom: '10rem',
                      }}
                      md={{ size: 12, order: 2 }}
                      xs={{ size: 12, order: 2 }}
                    >
                      <hr />
                      <div className="pb-2 text-end float-end">
                        <Button
                          type="button"
                          color="warning"
                          outline
                          disabled={!checks.length}
                          onClick={rejectDocument}
                          className={'me-75'}
                        >
                          Solicitud de cambio
                        </Button>
                        <Button
                          type="button"
                          color="primary"
                          disabled={!checks.length}
                          onClick={sign}
                          className={'me-75'}
                        >
                          Firmar
                        </Button>
                      </div>
                    </Col>

                    <Col
                      md={{ size: 12, order: 2 }}
                      xs={{ size: 12, order: 2 }}
                    >
                      <img
                        src={RubriDoc}
                        style={{
                          height: '40px',
                          position: 'absolute',
                          bottom: '25px',
                          right: '25px',
                        }}
                        className={'text-center m-auto'}
                        alt={'rubridoc'}
                      />
                    </Col>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default SignDocument
